.root {
	padding: var(--jpo-common-base-spacing);
	display: flex;
	gap: var(--jpo-common-base-spacing);

	&.italic {
		font-style: italic;
	}

	&.alignRight {
		justify-content: flex-end;
	}
}

.iconBefore {
	display: inline-flex;
	align-items: center;
}

.text {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
